import { render, staticRenderFns } from "./Relatives.vue?vue&type=template&id=90ad2532&"
import script from "./Relatives.vue?vue&type=script&lang=js&"
export * from "./Relatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports